import ReactStrapTable from "components/reactStrapTable";
import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { dateFormate, currencyFormat, cellRendererCheck } from "utils/columns";
import CellOptions from "components/reactStrapTable/components/CellOptions";
import View from "assets/icon/icon-icon-options-view-patient.svg";
import ViewHover from "assets/icon/icon-icon-options-view-patient_hover.svg";
import Loader from "components/Loader";
import useAxios from "hooks/useAxios";
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import plus from "assets/icon/plus-icon.svg";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import HoverImage from "react-hover-image/build";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import Maping from "assets/icon/MapIcon.svg";
import MapHover from "assets/icon/MapIconHover.svg";
import { toast } from "react-toastify";
import moment from "moment";
import { cloneDeep } from "lodash";
import Smallspinlogo from "assets/images/upload.gif";
import AddCrosswalkDrawer from "components/AddCrossWalk";
import { ModuleAccess } from "utils/moduleaccess";

let rowForEdit = {};


const CrosswalkTable = (props) => {
  const {
    collapseSider,
    toggleSider,
    Crosswalkflag,
    setChargeCodeflag,
    CrosswalkTableData,
    CrosswalkTotalrecords,
    loading,
    setLoading,
    refetch,
    crosswalksearch,
    CrosswalkcolumnFilters,
    onPageChange,
    onSearchColumnFilters,
    chargeCodeDetails,
    setChargeCodeDetails,
    mapingHistoryData,
    setMapingHistoryData,
    orgId,
    setCrosswalkTableData,
    status,
    setIshiddenflag,
    ishiddenflag,
    resetFilterFlag,
    SetResetFilterFlag,
    storedDate
  } = props;

useEffect(()=>{
   setChargeCodeflag(false);
   setAddMapings(false);
},[orgId])

  const API = useAxios();
  const [showWarning, setShowWarning] = useState('')
  //   const [CrosswalkTableData, setTableData] = useState(dummyData);
  const [bupperr, setBuppErr] = useState(false);
  const [addmapings, setAddMapings] = useState(false);
  const [originalData, setOriginalData] = useState({});
  // const [ishiddenflag, setIshiddenflag] = useState(false);
  const editRow = (rowData, isEdit = true) => {
    if (isEdit == false) {
      setIshiddenflag(false);
    }
    let tempData = [...CrosswalkTableData];
    if (isEdit) {
      let formattedRowData = { ...rowData };
      if (rowData.startDate) {
        const date = dateFormate(rowData.startDate);
        formattedRowData.startDate = date;
      }
      if (rowData.endDate) {
        const date = dateFormate(rowData.endDate);
        formattedRowData.endDate = date;
      }
      setOriginalData(formattedRowData);
    }
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.chargeDrugID === rowData?.chargeDrugID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });

    setCrosswalkTableData(tempData);
  };

  const saveUpdateRow = async () => {
    setIshiddenflag(false);
    let payload = { ...rowForEdit };
    if (payload.endDate != null) {
      payload.endDate = dateFormate(payload.endDate);
    }
    payload.startDate = dateFormate(payload.startDate);
    if (payload.bupp == "" || payload.bupp == null || payload.bupp == "0") {
      return setBuppErr(true)
    }
    if (payload.endDate && new Date(payload.endDate) < new Date(payload.startDate)) {
      return setShowWarning('Term Date must be Greater Than or Equal to EffectiveDate');
    }
    setLoading(true)
    if (payload.endDate !== null) {
      payload.endDate = moment(payload.endDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
    }
    payload.startDate = moment(payload.startDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
    delete payload.isEdit;
    try {
      const result = await API.post(
        `SBTenant/${orgId.tenantID}/Crosswalk/UpdateMappingHistory`,
        payload,
        {
          hasDefaultURL: true,
        }
      );

      if (result.data == true) {
        toast.success('updated successfully');
        refetch(true);
        setLoading(false);
      }
      else {
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };


  const togglemapingview = (row) => {
    fetchmapingHistory(row)
    setChargeCodeDetails(row)

    setChargeCodeflag(true);
  };
  const renderMapping = (rowData) => {
    if (hasPermission("HI"))
    if (rowData.isEdit != true)
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => togglemapingview(rowData)}
          hidden={rowData.reProcessedFlag == 'Y'}
          title="Map"
        >
          <HoverImage key="Maping" src={Maping} hoverSrc={MapHover} alt="" />
        </Button>
      );
  };

  const fetchmapingHistory = async (rowData) => {
    let chargeId = rowData?.chargeID
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/Crosswalk/ChargeCodeMappingHistory/${chargeId}`, crosswalksearch,
        {
          hasDefaultURL: true,
        }
      );
      if (data?.items?.length > 0) {
        setMapingHistoryData(data.items);
        setLoading(false);
      }
      else{
         setMapingHistoryData([]);
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  }
  const cellRenderEdit = (row) => {
    if (hasPermission("ED"))
      return <CellOptions row={row} onEdit={editRow} onSave={saveUpdateRow} setIshiddenflag={setIshiddenflag} ishiddenflag={ishiddenflag} />;
  };
  const cellRenderEdit1 = (rowData) => {
    // if (hasPermission('ED'))

    return (
      <div className="d-flex align-items-center">
        {cellRenderEdit(rowData)}
        {renderspin(rowData)}
        {renderMapping(rowData)}
      </div>
    );
  };

  const isEqual = (a, b) => {
    const normalize = val => (val === null || val === undefined || val === "") ? "" : val;
    return normalize(a).toString() === normalize(b).toString();
  };

  const updateRowValue = (value, col) => {
    if (col === 'endDate' && value !== "") {
      setShowWarning('');
    }
    const tempRow = { ...rowForEdit };

    if (rowForEdit.startDate) {
      tempRow.startDate = dateFormate(rowForEdit.startDate);
    }
    if (rowForEdit.endDate) {
      tempRow.endDate = dateFormate(rowForEdit.endDate);
    }

    tempRow[col] = value;

    const isSame =
      isEqual(originalData.bupp, tempRow.bupp) &&
      isEqual(originalData.startDate, tempRow.startDate) &&
      isEqual(originalData.notes, tempRow.notes) &&
      isEqual(originalData.endDate, tempRow.endDate);

    setIshiddenflag(!isSame);
    rowForEdit = tempRow;
  };

  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    if (formatterType == "date") {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          //hasTouched={hasTouched}
          showWarning={showWarning}
          crosswalktab='crosswalk'
          endDateFormatter={true}
          alwaysEditableCheckbox={alwaysEditableCheckbox}
        />
      );
    } else {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          wacErr={bupperr}
        // alwaysEditableCheckbox={alwaysEditableCheckbox}
        />
      );
    }
  };

  const renderspin = (rowData) => {

    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        // onClick={()=>togglemapingview(rowData)}
        title="Reprocessing in progress"
        hidden={rowData.reProcessedFlag == "N"}
      >
        <HoverImage
          key="Maping"
          src={Smallspinlogo}
          hoverSrc={Smallspinlogo}
          alt=""
        />
      </Button>
    );
  };
  const cellRenderLink = (row) => {
    return (
      <>
        <span
          className='text-decoration-underline d-inline-block cursor-pointer'
          onClick={() => togglemapingview(row)}
        >
          {row.chargeCode}
        </span>
      </>
    )
  }
  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit1(rowData),
      width: 118,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "chargeCode1",
      text: "Charge Code",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.chargeCode),
    },
    {
      dataField: "chargeDescription",
      text: "Charge Description",
      sort: false,
      width: 240,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.chargeDescription),
    },
    {
      dataField: "ndc",
      text: "NDC",
      sort: true,
      width: 150,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.ndc),
    },
    {
      dataField: "drugDescription",
      text: "NDC Description",
      sort: true,
      width: 240,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.drugDescription),
    },
    {
      dataField: "bupp",
      text: "BUPP",
      sort: true,
      width: 100,
      show: true,
      edit: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row, col) => formatter(row, col, "number"),
    },
    {
      dataField: "startDate",
      text: "Effective Date",
      sort: true,
      width: 150,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row, col) => formatter(row, col, "date"),
    },
    {
      dataField: "endDate",
      text: "Term Date",
      sort: true,
      width: 150,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row, col) => formatter(row, col, "date"),
    },
    {
      dataField: "fileID",
      text: "File ID",
      sort: true,
      width: 140,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.fileID),
    },
    {
      dataField: "notes",
      text: "Comments",
      edit: true,
      sort: true,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row, col) => formatter(row, col, 'text'),
    },
    {
      dataField: "modifiedByID",
      text: "Modified By",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      width: 150,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row, col) => dateFormate(row.modifiedDate),
    },
  ];
  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };
  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {

    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {

    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };
  const handleFilterCancel = () => {
    refetch(true);
  };
  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
      // setColFilters(colFilter);
    }
  };

  const handleExport = async () => {
    debugger;
    const filterObj = cloneDeep(crosswalksearch);
    //filterObj.ActiveButton = ActiveButton
    if (CrosswalkcolumnFilters && CrosswalkcolumnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...CrosswalkcolumnFilters];
    }

    const { access_token } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.OrgId = orgId.organizationID;
    // additionalCriteria.ContractId = 0;
    // additionalCriteria.POId = 0;
    additionalCriteria.OpaId = status;
    // additionalCriteria.CEId = 0;
    // additionalCriteria.ManufactureId = 0;

    var payload = {};
    payload.tenantID = orgId.tenantID
    payload.gridCode = "crosswalkactivecharges";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  }
  const hasPermission = (code) => {
    return ModuleAccess("CRW", code);
  }
  const handleAddMapping = (hasrefetch) => {
    setAddMapings(!addmapings);
    if (hasrefetch == true) {
      refetch(true);
    }
  };

  return (
    <div>
      {/* {loading && <Loader opacity={0.01} />} */}
      <div className="d-flex justify-content-between align-items-center">
        <h5 className="f-18 text-primary font-weight-600" style={{marginBottom:"0"}}>
          Crosswalk ({CrosswalkTotalrecords})
        </h5>
        <Button size="sm" color="primary" className="ms-auto upload_btn"
          hidden={!(hasPermission('AD'))}
          onClick={handleAddMapping}
          disabled={CrosswalkTableData.length == 0}>{" "}
          <span
            style={{ paddingRight: "4px", position: "relative", top: "-1px" }}
          >
            <img src={plus} alt="" />
          </span>
          Add
        </Button>
      </div>
      {/* <h5 className="f-16 text-primary font-weight-700">Crosswalk  ({CrosswalkTotalrecords})</h5> */}

      <hr />
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={
          CrosswalkTableData.length > 0
            ? `${collapseSider ? "collapse-fixed-height" : "fixed-height"}`
            : "default"
        }
      >
        <ReactStrapTable
          id="crosswalktable"
          height={550}
          fixedColumn
          width={1200}
          // reset={reset}
          hasPagination={CrosswalkTableData?.length > 0 ? true : false}
          data={CrosswalkTableData}
          columns={mainCol}
          onExport={handleExport}
          filters={crosswalksearch}
          totalRecords={CrosswalkTotalrecords}
          pageSize={crosswalksearch.pageSize}
          currentPage={crosswalksearch.currentPage}
          handleSort={onHandleSort}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          //accuntErr={accuntErr}
          collapseSider={collapseSider}
          toggleSider={toggleSider}
          showtoggle={true}
          resetFilterFlag={resetFilterFlag}
          SetResetFilterFlag={SetResetFilterFlag}
        />
      </div>
      <Modal
        isOpen={addmapings}
        toggle={handleAddMapping}
        style={{ maxWidth: "40%" }}

      >
        <ModalHeader toggle={handleAddMapping}>
          <h5 className="f-15 text-primary font-weight-700 mt-2">
            Add Crosswalk
          </h5>
        </ModalHeader>
        <ModalBody>
          <AddCrosswalkDrawer
            orgId={orgId}
            searchTerms={crosswalksearch}
            addCrosswalk={handleAddMapping}
            storedDate={storedDate}
          />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default CrosswalkTable;
